import { AfterContentInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { ErrorHandlerService, FolderService } from '@app/services';
import { Folder } from '@app/models';

export type ModalResult = Folder;
export interface ModalPublicProperties {
  folder: Folder;
}

@Component({
  selector: 'app-update-folder-modal',
  templateUrl: './update-folder-modal.component.html',
  styleUrls: ['./update-folder-modal.component.scss'],
  standalone: false
})
export class UpdateFolderModalComponent implements ModalPublicProperties, AfterContentInit {
  @Input() folder: Folder;
  form!: UntypedFormGroup;
  isLoading = false;
  @ViewChild('nameInput', { static: false }) private nameInput: ElementRef<HTMLInputElement>;

  constructor(public modal: NgbActiveModal, private formBuilder: UntypedFormBuilder, private foldersService: FolderService, private errorHandlerService: ErrorHandlerService) {
    this.form = this.formBuilder.group({ folder: this.formBuilder.group({ name: '' }) });
  }

  ngAfterContentInit() {
    this.form.get('folder.name').setValue(this.folder.name || '');
    setTimeout(() => this.nameInput.nativeElement.focus());
  }

  update() {
    this.isLoading = true;
    this.form.markAllAsTouched();
    this.foldersService
      .update({ id: this.folder.id, ...this.form.value })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: data => this.modal.close(data as ModalResult),
        error: error => this.errorHandlerService.handleValidation(this.form, error)
      });
  }
}
